import { useState } from "react";
import { TIDS } from "@/constants/testIds";

const DEFAULT_PROBLEMS = [
  { key: "low-sales", label: "Low webinar sales", pitch: "Get a proven registration + close framework so every webinar converts." },
  { key: "no-audience", label: "No audience yet", pitch: "Learn how creators run paid workshops even with 500 followers." },
  { key: "tech-overload", label: "Zoom & tools chaos", pitch: "Videoepreneur handles the tech — you focus on teaching." },
  { key: "no-show", label: "High no-show rate", pitch: "24h + 1h + 10min WhatsApp reminders lift attendance by 40%+." },
  { key: "manual-work", label: "Manual follow-ups", pitch: "Automated recording delivery + 7-day nurture built in." },
];

export default function ProblemSelector({ problems = DEFAULT_PROBLEMS, onChange, label = "What are you struggling with?" }) {
  const [active, setActive] = useState(problems[0]?.key);
  const current = problems.find((p) => p.key === active) || problems[0];

  const pick = (k) => {
    setActive(k);
    onChange && onChange(k);
  };

  return (
    <div className="vp-glass p-6 sm:p-8">
      <div className="vp-label mb-3">{label}</div>
      <div className="flex flex-wrap gap-2 mb-5">
        {problems.map((p) => {
          const isActive = p.key === active;
          return (
            <button
              key={p.key}
              type="button"
              onClick={() => pick(p.key)}
              data-testid={`${TIDS.problemPill}-${p.key}`}
              className={
                "px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 border " +
                (isActive
                  ? "bg-[#0B5CFF] text-[#0B0D17] border-[#2C6EFF]"
                  : "bg-transparent text-[#4A4D57] border-[#E4E6EC] hover:border-[#0B5CFF]/60 hover:text-[#0B0D17]")
              }
            >
              {p.label}
            </button>
          );
        })}
      </div>
      {current && (
        <p className="text-[#0B0D17] text-base sm:text-lg leading-relaxed">
          <span className="text-[#0B5CFF] font-semibold">You said: </span>
          {current.pitch}
        </p>
      )}
    </div>
  );
}
